(ns rothko.theme.manatee.form2.label
  (:require [rothko.styles.vars.basic :refer [font-sizes font-weights]]))

(def label
  {:primary
   {:font-size (:medium font-sizes)
    :font-weight (:bold font-weights)}})
